import BaseApi from "./BaseApi"

const IMAGES_ENDPOINT = "images/"

class ImageApi extends BaseApi {
    async getStringImage(offerId, imageName) {
        try {
          const endpoint = `${IMAGES_ENDPOINT}${offerId}/getBase64Image/${imageName}`
          const response = await this.get(endpoint)
          return response.data
        } catch (error) {
          throw new Error("Unable to retrieve string image - ImageApi")
        }
      }

      async getDefaultImage() {
        try {
          const endpoint = `${IMAGES_ENDPOINT}getDefaultBase64Image`
          const response = await this.get(endpoint)
          return response.data
        } catch (error) {
          throw new Error("Unable to retrieve default image - ImageApi")
        }
      }
}

export default new ImageApi()
